import { Helmet } from "react-helmet-async";
import useAppData from "../hooks/useAppData";

const PrivacyPolicy = () => {
	const { privacyPage } = useAppData();
	return (
		<>
			<Helmet>
				<title>{privacyPage.meta_title}</title>
				<meta name="description" content={privacyPage.meta_description} />
				<meta name="keywords" content={privacyPage.meta_keywords} />
			</Helmet>
			<div>
				<div className="container">
					<div
						className="row py-5"
						dangerouslySetInnerHTML={{ __html: privacyPage.content }}
					></div>
				</div>
			</div>
		</>
	);
};

export default PrivacyPolicy;
